import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { companies } from "../../data/content";
import { Eyebrow, ArrowLink, EASE } from "./motion";

export default function TabStrip() {
  const [active, setActive] = useState(0);
  const company = companies[active];

  return (
    <section className="relative overflow-hidden border-t border-white/10 bg-ink" aria-label="Our companies">
      <div className="absolute inset-0" aria-hidden="true">
        <AnimatePresence>
          <motion.img
            key={company.slug}
            src={company.image}
            alt=""
            initial={{ opacity: 0, scale: 1.05 }}
            animate={{ opacity: 0.3, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            className="absolute inset-0 h-full w-full object-cover"
          />
        </AnimatePresence>
        <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/70 to-ink/90" />
      </div>

      <div className="relative z-10">
        <div
          className="flex flex-wrap border-b border-white/10 px-3 lg:px-9"
          role="tablist"
          aria-label="Hapo Group companies"
        >
          {companies.map((c, i) => (
            <button
              key={c.slug}
              type="button"
              role="tab"
              aria-selected={active === i}
              data-testid={`tab-${c.slug}`}
              onClick={() => setActive(i)}
              className={`relative px-3 py-6 text-[10px] font-bold uppercase tracking-[0.18em] transition-colors duration-300 sm:px-5 sm:text-[11px] ${
                active === i ? "text-white" : "text-smoke hover:text-white"
              }`}
            >
              {c.tab}
              {active === i && (
                <motion.span layoutId="tab-underline" className="absolute inset-x-3 bottom-0 h-[2px] bg-gold sm:inset-x-5" />
              )}
            </button>
          ))}
        </div>

        <div className="flex min-h-[48vh] flex-col justify-center px-6 py-20 lg:px-12 lg:py-28">
          <AnimatePresence mode="wait">
            <motion.div
              key={company.slug}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -12 }}
              transition={{ duration: 0.35, ease: EASE }}
            >
              <Eyebrow>{company.name}</Eyebrow>
              <h2 className="mt-5 max-w-4xl text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
                {company.tabLine}
              </h2>
              <div className="mt-10">
                <ArrowLink light to={`/companies/${company.slug}`} testId={`tab-learn-more-${company.slug}`}>
                  Learn More
                </ArrowLink>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
}
